import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { AuditLog } from "../components/Group/auditLogs/types";
import { AuditLogs } from "../components/Group/auditLogs/types";

export const auditLogsAPI = createApi({
  reducerPath: "auditLogsAPI",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as any).auth.token;
      if (token) {
        headers.set("token", `${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ["AuditLogs", "AuditLog"],
  endpoints: (builder) => ({
    getLogs: builder.query<AuditLogs, string>({
      query: (groupID) => `/auditlogs/${groupID}`,
      providesTags: (result, error, groupID) =>
        result
          ? [{ type: "AuditLogs", id: groupID } as const]
          : [{ type: "AuditLogs", id: "LIST" } as const],
    }),
    getLogById: builder.query<AuditLog, { groupID: string; auditLogID: string }>({
      query: ({ groupID, auditLogID }) => `/auditlogs/${groupID}/${auditLogID}`,
      providesTags: (result, error, { auditLogID }) =>
        result ? [{ type: "AuditLog", id: auditLogID } as const] : [],
    }),
    downloadLogs: builder.query<Blob, string>({
      query: (groupID) => ({
        url: `/auditlogs/${groupID}/download`,
        method: "GET",
      }),
    }),
  }),
});

export const { useGetLogsQuery, useGetLogByIdQuery, useDownloadLogsQuery } = auditLogsAPI;
